import { SearchIcon } from "@heroicons/react/solid";
import React, { useEffect, useState } from "react";

type Props = {
  setSearch: any;
};

const SearchInput = ({ setSearch }: Props) => {
  const [query, setQuery] = useState("");

  useEffect(() => {
    const timeOutId = setTimeout(() => setSearch(query), 300);
    return () => clearTimeout(timeOutId);
  }, [query]);

  return (
    <div>
      <div className="relative mt-2 rounded-md shadow-sm">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
        </div>
        <input
          type="text"
          name="search"
          id="search"
          className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          placeholder="you@example.com"
          onChange={(event) => setQuery(event.target.value)}
        />
      </div>
    </div>
  );
};

export default SearchInput;
